'use strict';

require("moduleFold/bsszoomfield/styles/bsszoomfield.scss");

var bsszoomfield = angular.module("bss.zoomfield", [])
    .directive("bsszoomfield", ['$http', '$rootScope', '$timeout', "DSFactory", "GridFactory", "GridCfgFactory", "$q", require("./BSSZoomFieldDir")])    
;

module.exports = bsszoomfield;